import axios from './financeiroApi';

const parametrosReceitaApi = () => {
  const getPath = () => {
    return `/api/v1/backend/parametros/receita`;
  };

  return {
    cadastrar: (parametrosReceita) => {
      const url = getPath();
      return axios.post(url, parametrosReceita);
    },

    atualizar: (id, parametrosReceita) => {
      const url = `${getPath()}/${id}`;
      return axios.put(url, parametrosReceita);
    },

    getParametrosReceitaEmpresa: () => {
      const url = getPath();
      return axios.get(url);
    },
  };
};

export { parametrosReceitaApi };
